
export const formatDuration = (data, t, detailed = false) => {
  if (!data) return "";

  const translate = (key, fallback) => {
    if (typeof t === 'function') {
      return t(key);
    }
    return fallback;
  };

  let total = "";
  let approx = false;
  let rowsStr = "";
  let durationTypes = null;

  if (typeof data === "object" && data !== null) {
    total = data.value?.toString() || "";
    durationTypes = data.duration_types;
    if (data.reason && typeof data.reason === "string" && data.reason.includes("|")) {
      const [a, r] = data.reason.split("|");
      approx = (a === "true");
      rowsStr = r;
    }
  }
  else if (typeof data === "string" && data.includes("|")) {
    try {
      const parts = data.split("|");
      total = parts[0];
      approx = (parts[1] === "true");
      rowsStr = parts[2];
    } catch (e) {
      return data;
    }
  }
  else {
    const num = parseFloat(data);
    if (!isNaN(num)) {
      const formattedTotal = Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
      return `${formattedTotal} ${translate('Days', 'Days')}`;
    }
    return data;
  }

  const approxPrefix = approx ? "≈ " : "";

  // Only show detailed breakdown if explicitly requested
  if (detailed) {
    if (durationTypes && typeof durationTypes === 'string') {
      const parts = durationTypes.split(',');
      const output = parts.map(part => {
        const val = parseFloat(part);
        if (val === 0 || isNaN(val)) return null;
        const unitChar = part.replace(/[0-9.]/g, '');
        const unitMap = {
          'm': { key: 'Minutes', fallback: 'Minutes' },
          'h': { key: 'Hours', fallback: 'Hours' },
          'd': { key: 'Days', fallback: 'Days' },
          'w': { key: 'Weeks', fallback: 'Weeks' },
          'M': { key: 'Months', fallback: 'Months' },
          'y': { key: 'Years', fallback: 'Years' }
        };
        const unitInfo = unitMap[unitChar] || { key: unitChar, fallback: unitChar };
        return `${val} ${translate(unitInfo.key, unitInfo.fallback)}`;
      }).filter(Boolean);

      if (output.length > 0) {
        return `${approxPrefix}${output.join(', ')}`;
      }
    }

    if (rowsStr && rowsStr.trim() !== "") {
      const rows = rowsStr.split(',').filter(r => r.includes(':')).map(r => {
        const [v, u] = r.split(':');
        if (!v || !u) return "";
        const formattedUnit = u.charAt(0).toUpperCase() + u.slice(1);
        return `${v} ${translate(formattedUnit, formattedUnit)}`;
      }).filter(r => r !== "");

      if (rows.length > 0) {
        return `${approxPrefix}${rows.join(', ')}`;
      }
    }
  }

  if (total !== "") {
    const num = parseFloat(total);
    const formattedTotal = !isNaN(num) ? (Number.isInteger(num) ? num : parseFloat(num.toFixed(2))) : total;
    return `${approxPrefix}${formattedTotal} ${translate('Days', 'Days')}`;
  }

  return "";
};

export const getDurationDetails = (data) => {
  if (!data) return null;
  let total = 0, approx = false, rowsStr = "", durationTypes = null;

  if (typeof data === 'object') {
    total = data.value;
    durationTypes = data.duration_types;
    if (data.reason?.includes('|')) {
      const [a, r] = data.reason.split('|');
      approx = (a === 'true');
      rowsStr = r;
    }
  } else if (typeof data === 'string' && data.includes('|')) {
    const parts = data.split('|');
    total = parseFloat(parts[0]);
    approx = (parts[1] === 'true');
    rowsStr = parts[2];
  } else {
    return null;
  }

  let rows = [];

  // Prioritize duration_types
  if (durationTypes && typeof durationTypes === 'string') {
    const parts = durationTypes.split(',');
    const unitMap = {
      'm': 'minutes',
      'h': 'hours',
      'd': 'days',
      'w': 'weeks',
      'M': 'months',
      'y': 'years'
    };
    rows = parts.map(part => {
      const v = parseFloat(part);
      const unitChar = part.replace(/[0-9.]/g, '');
      return { value: v.toString(), unit: unitMap[unitChar] || unitChar };
    });
  }
  // Fallback to rowsStr
  else if (rowsStr) {
    rows = rowsStr.split(',').map(r => {
      const [v, u] = r.split(':');
      return { value: v, unit: u };
    });
  }

  return {
    total,
    approximate: approx,
    rows
  };
};
